export var diamondBackground = {right:'$_1v2C_',left:'$_1eBQD'};